import React from "react";
import {
  ERROR_TIMEOUT,
  DEFAULT_ERROR_MESSAGE,
  INVALID_SESSION,
  MODAL_SIZE,
} from "../../App.config";
import setLoaderAction from "./loaderAction";
import types from "../actionTypes";
import * as apiServices from "../../services/apiServices";
import * as toastAction from "../actions/toastAction";
import history from "../../utilities/history";
import apiConfig from "../../App.config";
import * as utilities from "../../utilities/utils";
import { closeRemoveModal, openSetModal } from "./modalActions";
import { isSessionValid } from "./profileAction";
import AttachmentDescription from "../../containers/Std/AttachmentDescription";
import {getJob,getSupervisorListByCompany} from "./commonAction"
import {getAllPendingApplications} from "./notificationAction"
import { setSuccessMessage } from "./commonAction";


/************************************ ACTIONS ****************************************/

function setCityAction(city) {
  return {
    type: types.SET_CITY,
    city,
  };
}

function setCountryAction(country) {
  return {
    type: types.SET_COUNTRY,
    country,
  };
}

function setStateAction(state) {
  return {
    type: types.SET_STATE,
    state,
  };
}

function setPlanLinkAction(planLink) {
  return {
    type: types.SET_PLAN_LINK,
    planLink,
  };
}

function setPrefferedLangugageAction(prefferedLanguage) {
  return {
    type: types.SET_PREFFERED_LANG,
    prefferedLanguage,
  };
}

function setEmploymentStatusAction(employmentStatus) {
  return {
    type: types.SET_EMPLOYMENT_STATUS,
    employmentStatus,
  };
}

function setMinimumFormStepAction(minSteps) {
  return {
    type: types.SET_MIN_STEPS,
    minSteps,
  };
}

function setMaximumFormStepAction(maxSteps) {
  return {
    type: types.SET_MAX_STEPS,
    maxSteps,
  };
}

function setCurrentFormStepAction(step) {
  return {
    type: types.SET_CURRENT_STEP,
    step,
  };
}

function setIsSearchAction(isSearch) {
  return {
    type: types.SET_IS_SEARCH,
    isSearch,
  };
}

function setLocationAction(location) {
  return {
    type: types.SET_LOCATION,
    location,
  };
}

function setRegionAction(region) {
  return {
    type: types.SET_REGION,
    region,
  };
}

function setJobAction(job) {
  return {
    type: types.SET_JOB,
    job,
  };
}

function setDepartmentAction(department) {
  return {
    type: types.SET_DEPARTMENT,
    department,
  };
}

// function setSupervisorListAction(supervisorList) {
//   return {
//     type: types.SET_SUPERVISOR_LIST,
//     supervisorList,
//   };
// }

function setClientInfoAction(clientInfo) {
  return {
    type: types.SET_CLIENT_INFO,
    clientInfo,
  };
}

function setClientInfoByIdAction(clientInfoById) {
  return {
    type: types.SET_CLIENT_INFO_BY_ID,
    clientInfoById,
  };
}

function setAttachmentAction(attachment) {
  return {
    type: types.SET_ATTACHMENT,
    attachment,
  };
}

function setErsPdfLinkAction(ersFormPdfLink) {
  return {
    type: types.SET_ERS_FORM_PDF,
    ersFormPdfLink,
  };
}
function setIsAddedAction(isAdded) {
  return {
    type: types.IS_ADDED,
    isAdded,
  };
}

function setStdEmployeeStatement(stdEmployeeStatememt) {
  return {
    type: types.SET_STD_EMPLOYEE_STATEMENT,
    stdEmployeeStatememt
  }
}


/************************************ ACTION CREATORS ****************************************/

  export const resetStdEmployeeStatement = () => (dispatch) => {
  dispatch(setStdEmployeeStatement([]));
}

export const resetState = () => (dispatch) => {
  dispatch(setCurrentFormStep(1));
   //dispatch(setPendingApplications(undefined));
  // dispatch(setAirEmployeeStatement(undefined));
};

export const prepareStdConfigData = (companyId) => (dispatch) => {
  dispatch(getCountry());
  // dispatch(getCity());
  dispatch(getPlanLink(companyId));
  // dispatch(getPrefferedLangugage());
  dispatch(getState(null));
  dispatch(getJob(companyId));
  // dispatch(getEmploymentStatus());
  dispatch(getLoction(companyId));
  dispatch(getRegion(companyId));
  dispatch(getDepartment(companyId));
  dispatch(getClientInfo(companyId));
  dispatch(getSupervisorListByCompany(companyId));
};

//Setting form step count

export const setMaximumFormStep = (maxCount) => (dispatch) => {
  dispatch(setMaximumFormStepAction(maxCount));
};

export const setMinimumFormStep = (minCount) => (dispatch) => {
  dispatch(setMinimumFormStepAction(minCount));
};

export const setCurrentFormStep = (stepCount) => (dispatch) => {
  dispatch(setCurrentFormStepAction(stepCount));
};

export const setIsSearch = (isSearch) => (dispatch) => {
  dispatch(setIsSearchAction(isSearch));
};

export const resetIsAdded = (isAdded) => (dispatch) => {
  dispatch(setIsAddedAction(isAdded));
};

export const resetErsApplicationUrl = () => (dispatch) => {
  dispatch(setErsPdfLinkAction(undefined));
};

// export const setJob = (jobDetails) => (dispatch) => {
//   dispatch(setJobAction(jobDetails));
// };

export const setAttachment = (attachment) => (dispatch) => {
  dispatch(setAttachmentAction(attachment));
};

export const showAlertError = (labelKey, errorMessage) => (dispatch) => {
  dispatch(
    toastAction.showValidationErrorMessage(true, labelKey, errorMessage)
  );
  setTimeout(() => {
    dispatch(toastAction.showValidationErrorMessage(false, undefined, ""));
  }, ERROR_TIMEOUT);
};

const responseError = (errorMessage) => (dispatch) => {
  if (errorMessage) {
    dispatch(setLoaderAction(false));
    dispatch(toastAction.showErrorMessage(true, errorMessage));
    setTimeout(() => {
      dispatch(toastAction.showErrorMessage(false, ""));
    }, ERROR_TIMEOUT);
  } else {
    dispatch(setLoaderAction(false));
    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
    setTimeout(() => {
      dispatch(toastAction.showErrorMessage(false, ""));
    }, ERROR_TIMEOUT);
  }
};

export const getCountry = () => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getCountry()
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setCountryAction(data.country));
      } else {
        dispatch(responseError(data.errorMessage));
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getCity = () => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getCity()
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setCityAction(data.response));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getLoction = (companyId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getLoction(companyId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setLocationAction(data.companyLocationList));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

// export const getJob = () => (dispatch) => {
//   dispatch(setLoaderAction(true));
//   return apiServices
//     .getCompanyJobs()
//     .then(({ data }) => {
//       if (dispatch(isSessionValid(data.errorMessage))) {
//         return;
//       }
//       if (data.isTransactionSucceed) {
//         dispatch(setLoaderAction(false));
//         dispatch(setJobAction(data.companyJobs));
//       } else {
//         if (data.errorMessage) {
//           dispatch(setLoaderAction(false));
//           dispatch(toastAction.showErrorMessage(true, data.errorMessage));
//           setTimeout(() => {
//             dispatch(toastAction.showErrorMessage(false, ""));
//           }, ERROR_TIMEOUT);
//         } else {
//           dispatch(setLoaderAction(false));
//           dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
//           setTimeout(() => {
//             dispatch(toastAction.showErrorMessage(false, ""));
//           }, ERROR_TIMEOUT);
//         }
//       }
//     })
//     .catch((error) => {
//       dispatch(setLoaderAction(false));
//       dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
//       setTimeout(() => {
//         dispatch(toastAction.showErrorMessage(false, ""));
//       }, ERROR_TIMEOUT);
//     });
// };

// export const addNewJobTitle = (jobDetails, locationID) => (dispatch) => {
//   dispatch(setLoaderAction(true));
//   return apiServices
//     .addJobDetils(jobDetails)
//     .then(({ data }) => {
//       if (dispatch(isSessionValid(data.errorMessage))) {
//         return;
//       }
//       if (data.isTransactionSucceed) {
//         dispatch(setLoaderAction(false));
//         dispatch(getJob());
//         dispatch(closeRemoveModal());
//       } else {
//         if (data.errorMessage) {
//           dispatch(setLoaderAction(false));
//           dispatch(toastAction.showErrorMessage(true, data.errorMessage));
//           setTimeout(() => {
//             dispatch(toastAction.showErrorMessage(false, ""));
//           }, ERROR_TIMEOUT);
//         } else {
//           dispatch(setLoaderAction(false));
//           dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
//           setTimeout(() => {
//             dispatch(toastAction.showErrorMessage(false, ""));
//           }, ERROR_TIMEOUT);
//         }
//       }
//     })
//     .catch((error) => {
//       dispatch(setLoaderAction(false));
//       dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
//       setTimeout(() => {
//         dispatch(toastAction.showErrorMessage(false, ""));
//       }, ERROR_TIMEOUT);
//     });
// };

export const getRegion = (companyId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getRegion(companyId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setRegionAction(data.companyRegionList));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getDepartment = (companyId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getDepartment(companyId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setDepartmentAction(data.companyDepartmentList));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getPrefferedLangugage = () => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getLanguage()
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setPrefferedLangugageAction(data.response));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getState = (countryId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getState(countryId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setStateAction(data.province));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getEmploymentStatus = () => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getEmploymentStatus()
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setEmploymentStatusAction(data.response));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getPlanLink = (companyId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getPlanlink(companyId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setPlanLinkAction(data.planLink));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getClientInfo = (companyId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getClientInfo(companyId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setClientInfoAction(data.clientBasicinfoList));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const setClientInfoByIdOrEin = (data) => (dispatch) => {
  dispatch(setClientInfoByIdAction(data));
};

export const getClientInfoById = (ein, clientId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getClientInfoByEinOrClientId(ein, clientId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setClientInfoByIdAction(data.clientInfo));
        dispatch(setIsSearchAction(true));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

// export const setSuccessMessage = (message) => (dispatch) => {
//   dispatch(setSuccessMessageValue(message));
//   }

export const addstdemployeestatement = (stdData,managerId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .addstdemployeestatement(stdData)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(
          setErsPdfLinkAction(
            // data?.ersFormPDF?.fileUploadPath?.replace("~/", apiConfig.BASEURL)
            data?.ersFormPDF?.fileUploadPath
            )
        );
        dispatch(setSuccessMessage(data.successMessage));
        dispatch(setIsAddedAction(true));
        dispatch(setAttachmentAction([]));
        dispatch(getAllPendingApplications(managerId));
        
        // dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        // setTimeout(() => {
        //   dispatch(toastAction.showSuccessMessage(false, ""));
        // }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const uploadFiles = (file, allFiles, props) => (dispatch, getState) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .uploadFiles(file)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        let attachmentData = [
          ...allFiles,
          {
            // fullFilePath: data?.fileUploadData.path.replace(
            //   "~/",
            //   apiConfig.BASEURL
            // ),
            fullFilePath: data?.fileUploadData.path,
            attachmentDescription: "",
            ...data.fileUploadData,
          },
        ];

        dispatch(setAttachmentAction(attachmentData));
        dispatch(openSetModal(<AttachmentDescription {...props}
          index={getState()?.stdReducer?.attachment.length - 1}
          attachmentDescription={getState()?.stdReducer?.attachment.attachmentDescription}
          attachment={getState()?.stdReducer?.attachment} />, MODAL_SIZE.MODAL_SM, true));
      } else {

        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
        else {

          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const removeFiles = (filePath, isDocs, index, allAttachments) => (
  dispatch
) => {
  dispatch(setLoaderAction(true));
  filePath = filePath.replace(apiConfig.BASEURL, "/");
  return apiServices
    .removeFile(filePath, isDocs)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        let updatedAttachment = [];
        updatedAttachment = [...allAttachments];
        updatedAttachment.splice(index, 1);
        dispatch(setAttachmentAction(updatedAttachment));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

// export const getSupervisorListByCompany = () => (dispatch) => {
//   dispatch(setLoaderAction(true));
//   return apiServices
//     .getSupervisorListByCompany()
//     .then(({ data }) => {
//       if (dispatch(isSessionValid(data.errorMessage))) {
//         return;
//       }
//       if (data.isTransactionSucceed) {
//         dispatch(setLoaderAction(false));
//         dispatch(setSupervisorListAction(data.listSupervisors));
//       } else {
//         if (data.errorMessage) {
//           dispatch(setLoaderAction(false));
//           dispatch(toastAction.showErrorMessage(true, data.errorMessage));
//           setTimeout(() => {
//             dispatch(toastAction.showErrorMessage(false, ""));
//           }, ERROR_TIMEOUT);
//         } else {
//           dispatch(setLoaderAction(false));
//           dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
//           setTimeout(() => {
//             dispatch(toastAction.showErrorMessage(false, ""));
//           }, ERROR_TIMEOUT);
//         }
//       }
//     })
//     .catch((error) => {
//       dispatch(setLoaderAction(false));
//       dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
//       setTimeout(() => {
//         dispatch(toastAction.showErrorMessage(false, ""));
//       }, ERROR_TIMEOUT);
//     });
// };

export const downloadAllCase = (ein, isAir,isPDF) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .downloadAllCase(ein, isAir,isPDF)
    .then(({ data }) => {
      dispatch(setLoaderAction(false));
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download',"file.zip"); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
}

export const downloadCase = (ein, isAir, caseId,isPDF) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .downloadCase(ein, isAir, caseId,isPDF)
    .then(({ data }) => {
      dispatch(setLoaderAction(false));
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download',isPDF ? "file.pdf" : "file.xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
}

// export const addNewManager = (managerDetails) => (dispatch) => {
//   dispatch(setLoaderAction(true));
//   return apiServices
//     .addNewManager(managerDetails)
//     .then(({ data }) => {
//       if (dispatch(isSessionValid(data.errorMessage))) {
//         return;
//       }
//       if (data.isTransactionSucceed) {
//         dispatch(setLoaderAction(false));
//         dispatch(getSupervisorListByCompany());
//         dispatch(closeRemoveModal());
//       } else {
//         if (data.errorMessage) {
//           dispatch(setLoaderAction(false));
//           dispatch(toastAction.showErrorMessage(true, data.errorMessage));
//           setTimeout(() => {
//             dispatch(toastAction.showErrorMessage(false, ""));
//           }, ERROR_TIMEOUT);
//         } else {
//           dispatch(getSupervisorListByCompany());
//           dispatch(closeRemoveModal());
//           // dispatch(setLoaderAction(false));
//           // dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
//           // setTimeout(() => {
//           //   dispatch(toastAction.showErrorMessage(false, ""));
//           // }, ERROR_TIMEOUT);
//         }
//       }
//     })
//     .catch((error) => {
//       dispatch(setLoaderAction(false));
//       dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
//       setTimeout(() => {
//         dispatch(toastAction.showErrorMessage(false, ""));
//       }, ERROR_TIMEOUT);
//     });
// };

export const getStdEmployeeStatement = (employerDetailedId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getStdEmployeeStatement(employerDetailedId)
    .then(({ data }) => {
      dispatch(setLoaderAction(false));
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setStdEmployeeStatement(data));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};
